import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/admin/layout/Layout'
import LayoutSidebarless from '../views/admin/layout/LayoutSidebarless'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [
  { path: '/forgot', component: () => import('@/views/forgot/index'), hidden: true },
  { path: '/response/:email', component: () => import('@/views/forgot/response'), hidden: true },
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/reset', component: () => import('@/views/forgot/reset'), hidden: true },
  { path: '/success', component: () => import('@/views/forgot/success'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '', component: () => import('@/views/home/index'), hidden: true },
  { path: '/settings', component: () => import('@/views/home/settings'), hidden: true },
  { path: '/legal', component: () => import('@/views/legal/legal'), hidden: true },
  { path: '/privacy', component: () => import('@/views/legal/privacy'), hidden: true },
  { path: '/cookie', component: () => import('@/views/legal/cookie'), hidden: true },
  { path: '/unconfirmed', component: () => import('@/views/unconfirmed/index'), hidden: true },
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
  mode: 'history'
})

export const unconfirmedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/index'), hidden: true }
]

export const rejectedRouterMap = [
  { path: '/dashboard', component: () => import('@/views/unconfirmed/rejected'), hidden: true }
]

export const asyncRouterMap = [
  {
    path: '/z/:branchId/tkitchen/overview',
    component: Layout,
    redirect: '',
    name: 'TKitchen',
    meta: { feature: 'tkitchen', title: 'Overview' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/overview'),
        meta: { title: 'TKitchen' }
      }
    ],
    hidden: true,
    branch: true
  },
  // {
  //   path: '/z/:branchId/tkitchen/mobile_app',
  //   component: Layout,
  //   redirect: '',
  //   name: 'Reporting',
  //   meta: { tkitchenModule: 'mobile_app', feature: 'tkitchen', title: 'Reporting' },
  //   children: [
  //     {
  //       path: '',
  //       component: () => import('@/views/tkitchen/dashboard'),
  //       meta: { title: 'Dashboard' }
  //     }
  //   ],
  //   alwaysShow: true,
  //   branch: true
  // },
  {
    path: '/z/:branchId/tkitchen/mobile_app',
    component: Layout,
    redirect: '',
    name: 'Home',
    meta: { tkitchenModule: 'mobile_app', relationRoles: ['Owner', 'Warehouse'], feature: 'tkitchen', title: 'Home' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/mobile_app/home'),
        meta: { title: 'Home' }
      },
    ],
    alwaysShow: true,
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/tkitchen/mobile_app/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { tkitchenModule: 'mobile_app', relationRoles: ['Owner', 'Warehouse'], feature: 'tkitchen', title: 'Warehouse' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/mobile_app/recievingrawmaterialscanlogs'),
        meta: { title: '01 Receiving Raw Materials' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/mobile_app/packinglist',
    component: Layout,
    redirect: '',
    name: 'Packing List',
    meta: { tkitchenModule: 'mobile_app', relationRoles: ['Owner', 'Warehouse'], feature: 'tkitchen', title: 'Packing List' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/mobile_app/packinglist'),
        meta: { title: '02 Create Packing List' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app',
    component: Layout,
    redirect: '',
    name: 'Reporting',
    meta: { tkitchenModule: 'web_app', feature: 'tkitchen', title: 'Reporting' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/dashboard'),
        meta: { title: 'Dashboard' }
      },
      {
        path: 'productstocks',
        component: () => import('@/views/tkitchen/productstocks'),
        meta: { title: 'Stock Control' }
      },
      // {
      //   path: 'stocktakes',
      //   component: () => import('@/views/tkitchen/stocktakes'),
      //   meta: { title: 'Stock Take' }
      // },
      // {
      //   path: 'reporting',
      //   component: () => import('@/views/tkitchen/reporting'),
      //   meta: { title: 'Reporting' }
      // },
      // {
      //   path: 'transactionlogs',
      //   component: () => import('@/views/tkitchen/transactionlogs'),
      //   meta: { title: '[WIP] Transaction Logs' }
      // }
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/register',
    component: Layout,
    redirect: '',
    name: 'Register',
    meta: { tkitchenModule: 'web_app', feature: 'tkitchen', title: 'Register' },
    children: [
      {
        path: 'whlocations',
        component: () => import('@/views/tkitchen/whlocations'),
        meta: { title: 'Store Locations' }
      },
      {
        path: 'categories',
        component: () => import('@/views/tkitchen/categories'),
        meta: { title: 'Categories' }
      },
      {
        path: 'products',
        component: () => import('@/views/tkitchen/products'),
        meta: { title: 'Product Code' }
      },
      {
        path: 'bom',
        component: () => import('@/views/tkitchen/finishedgoods'),
        meta: { title: 'BOM' }
      },
      {
        path: 'customers',
        component: () => import('@/views/tkitchen/customers'),
        meta: { title: 'Customers' }
      },
      // {
      //   path: 'suppliers',
      //   component: () => import('@/views/tkitchen/suppliers'),
      //   meta: { title: 'Suppliers' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/warehouse',
    component: Layout,
    redirect: '',
    name: 'Warehouse',
    meta: { tkitchenModule: 'web_app', relationRoles: ['Owner', 'Warehouse'], feature: 'tkitchen', title: 'Warehouse' },
    children: [
      {
        path: 'inboundqrcodes',
        component: () => import('@/views/tkitchen/partqrcodes'),
        meta: { title: '01 Warehouse QRCode' }
      },
      {
        path: 'inboundscan',
        component: () => import('@/views/tkitchen/partscanlogs'),
        meta: { title: '02 Receiving Raw Materials' }
      },
      // {
      //   path: 'packedproducts',
      //   component: () => import('@/views/tkitchen/packedproducts'),
      //   meta: { title: '03 Packed Products' }
      // },
      {
        path: 'requestedwhparts',
        component: () => import('@/views/tkitchen/requestedwhparts'),
        meta: { title: '04 Requested Raw Material', badge: 'requestedwhpart' },
      },
      // {
      //   path: 'requestedscansimulator',
      //   component: () => import('@/views/tkitchen/requestedwhpartscanlogs'),
      //   meta: { title: '06 Requested Scan Simulator' }
      // },
      // {
      //   path: 'receivedwhfinishedgoods',
      //   component: () => import('@/views/tkitchen/receivedwhproducts'),
      //   meta: { title: '11 Inbound Verify' }
      // },
      // {
      //   path: 'cartonqrcodes',
      //   component: () => import('@/views/tkitchen/cartonqrcodes'),
      //   meta: { title: '12 Pallet QRCode' }
      // },
      // {
      //   path: 'cartonpair',
      //   component: () => import('@/views/tkitchen/cartonscanlogs'),
      //   meta: { title: '13 Pallet Pair' }
      // },
      // {
      //   path: 'packedcartons',
      //   component: () => import('@/views/tkitchen/packedcartons'),
      //   meta: { title: '14 Packed Pallets' }
      // },
      {
        path: 'purchaseorders',
        component: () => import('@/views/tkitchen/purchaseorders'),
        meta: { title: '06 Admin Requests', badge: 'purchaseorder' }
      },
      // {
      //   path: 'packinglistpair',
      //   component: () => import('@/views/tkitchen/packinglistscanlogs'),
      //   meta: { title: '16 Packing Lists' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/simulators',
    component: Layout,
    redirect: '',
    name: 'Simulator',
    meta: { tkitchenModule: 'web_app', relationRoles: ['Owner', 'Warehouse'], feature: 'tkitchen', title: 'Simulator' },
    children: [
      {
        path: 'weightsimulator',
        component: () => import('@/views/tkitchen/weightsimulator'),
        meta: { title: 'Weight Simulator' }
      },
    ],
    alwaysShow: true,
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/production',
    component: Layout,
    redirect: '',
    name: 'Production',
    meta: { tkitchenModule: 'web_app', relationRoles: ['Owner', 'Production'], feature: 'tkitchen', title: 'Production' },
    children: [
      {
        path: 'requestprparts',
        component: () => import('@/views/tkitchen/requestprparts'),
        meta: { title: '03 Material Request' }
      },
      {
        path: 'receivedprparts',
        component: () => import('@/views/tkitchen/receivedprparts'),
        meta: { title: '05 Receive Materials' }
      },
      // {
      //   path: 'produceqrcodes',
      //   component: () => import('@/views/tkitchen/productqrcodes'),
      //   meta: { title: '08 Production QRCode' }
      // },
      // {
      //   path: 'producescan',
      //   component: () => import('@/views/tkitchen/productscanlogs'),
      //   meta: { title: '09 Produce Scan' }
      // },
      // {
      //   path: 'packedfinishedgoods',
      //   component: () => import('@/views/tkitchen/packedproductsproduction'),
      //   meta: { title: '10 Packed Cartons' }
      // },
    ],
    branch: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/warranty',
    component: Layout,
    redirect: '',
    name: 'Warranty Tracking',
    meta: { tkitchenModule: 'web_app', relationRoles: ['Owner'], feature: 'tkitchen', title: 'Warranty Tracking' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/productwarranties'),
        meta: { title: 'Product Warranties' }
      }
    ],
    branch: true,
    alwaysShow: true
  },
  {
    path: '/z/:branchId/tkitchen/web_app/manual',
    component: Layout,
    redirect: '',
    name: 'User Manual',
    meta: { tkitchenModule: 'web_app', feature: 'tkitchen', title: 'User Manual' },
    children: [
      {
        path: '',
        component: () => import('@/views/tkitchen/pdfmanual'),
        meta: { title: 'User Manual' }
      },
    ],
    branch: true,
    alwaysShow: true
  },

  // default - has branch
  {
    path: '/z/:branchId/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator' }
      }
    ],
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password' }
      }
    ],
    branch: true,
    hidden: true
  },
  {
    path: '/z/:branchId/default',
    component: Layout,
    redirect: '',
    name: 'Default',
    meta: { title: 'Default' },
    children: [
      {
        path: '',
        component: () => import('@/views/admin/default/index'),
        meta: { title: 'Default' }
      }
    ],
    hidden: true,
    branch: true
  },

  // default - no branch
  {
    path: '/branch',
    component: Layout,
    redirect: 'profile',
    name: 'Co. Settings',
    meta: { title: 'Co. Settings' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/branch/profile'),
        meta: { title: 'Profile' }
      },
      {
        path: 'email',
        component: () => import('@/views/settings/branch/email'),
        meta: { title: 'Email' }
      },
      {
        path: 'collaborator',
        component: () => import('@/views/settings/branch/collaborator'),
        meta: { title: 'Collaborator' }
      }
    ]
  },
  {
    path: '/account',
    component: Layout,
    redirect: 'profile',
    name: 'User Settings',
    meta: { title: 'User Settings' },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/settings/user/profile'),
        meta: { title: 'Profile' }
      },
      {
        path: 'password',
        component: () => import('@/views/settings/user/password'),
        meta: { title: 'Password' }
      }
    ]
  },
  {
    path: '/users',
    component: Layout,
    redirect: 'users',
    name: 'Users',
    meta: { roles: ['generalmanager'], title: 'Users' },
    children: [{
      path: '',
      component: () => import('@/views/admin/users/index'),
      meta: { title: 'Users' }
    }]
  }
  // { path: '*', redirect: '/404', hidden: true }
]



// WEBPACK FOOTER //
// ./src/router/index.js